import { combineReducers } from 'redux'

import exercicio from './exercicioListaIndicadoresPlanejamentoEstrategico'
import planoEstrategico from './planoEstrategicoPlanejamentoEstrategico'
import tema from './temaListaIndicadoresPlanejamentoEstrategico'
import objetivoEstrategico from './objetivoEstrategiaListaIndicadores'
import unidadeMedida from './unidadeMedidaPlanejamentoEstrategico'

export default combineReducers({
    exercicio,
    planoEstrategico,
    tema,
    objetivoEstrategico,
    unidadeMedida,
})
